import enJson from "./translation/en.json";

export type MessageID = keyof typeof enJson;
export type MessageJson = { [key in MessageID]: string };
export enum Locale {
  en = "en",
  zhHant = "zhHant",
}
export function localeFromLocaleKey(
  k: string | null | undefined
): Locale | null {
  switch (k) {
    case "en":
      return Locale.en;
    case "zhHant":
      return Locale.zhHant;
    default:
      return null;
  }
}
